import * as Styled from '../../components/PoweredBy/PoweredBy.styled';
import { CDN_STATIC_ASSETS } from '../../utils';
import { AllianzLogoSecondary } from '../../components/PoweredBy/PoweredBy.styled';

export const PoweredByLogoTag = () => {
  return (
    <Styled.AllianzPartnershipLogo>
      In partnership with
      <AllianzLogoSecondary
        src={`${CDN_STATIC_ASSETS}/images/thirdparty/AllianzSecondary.svg`}
        alt={'Allianz Logo'}
      />
    </Styled.AllianzPartnershipLogo>
  );
};
